module.exports = __webpack_public_path__ + "/build/web/svg/ic-minus-white.4528c1cf30252b6b8dbb185f63358f97.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/ic-minus-white.svg
// module id = 221
// module chunks = 13